var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0b75c2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M6.9 21.1c1.5.9 3.3 1.4 5.1 1.4 5.5 0 10-4.5 10-10s-4.5-10-10-10S2 7 2 12.5c0 1.8.5 3.5 1.3 5l-.86 3.306a1 1 0 0 0 1.243 1.213z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0b75c2",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M16.5 15.348c0 .162-.036.329-.113.491a1.9 1.9 0 0 1-.306.459 2 2 0 0 1-.74.531q-.405.17-.878.171-.69.001-1.47-.328a8 8 0 0 1-1.55-.892 13 13 0 0 1-1.478-1.26 13 13 0 0 1-1.257-1.471 8 8 0 0 1-.884-1.534q-.324-.772-.324-1.472c0-.306.054-.598.162-.868q.161-.413.519-.752.434-.425.937-.423a.85.85 0 0 1 .365.081c.117.054.22.135.302.252l1.046 1.472q.12.167.18.315c.04.094.063.189.063.274a.6.6 0 0 1-.095.32 1.5 1.5 0 0 1-.252.319l-.343.356a.24.24 0 0 0-.072.18q0 .05.014.103c.013.036.027.063.036.09q.12.224.419.576.303.352.653.711c.244.239.478.459.717.662q.351.293.581.413l.082.037a.3.3 0 0 0 .112.018.25.25 0 0 0 .185-.077l.342-.338q.17-.169.325-.252a.6.6 0 0 1 .32-.094.7.7 0 0 1 .275.059q.148.06.315.175l1.492 1.058a.7.7 0 0 1 .248.287.9.9 0 0 1 .072.351z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.abebc560519c0cc24ca0fc719105eac0.svg";
export { ForwardRef as ReactComponent };